import {
  Add,
  Wifi,
  WifiOff,
  PrecisionManufacturingOutlined,
  Dashboard,
  VpnKey,
  Business,
} from "@mui/icons-material";

function NavItems(summary, user) {
  const sections = [
    {
      title: "Devices",
      pages: [
        {
          href: "/devices",
          icon: Dashboard,
          title: "Dashboard",
          badge:
            typeof summary?.total === "number"
              ? summary.total.toString()
              : null,
        },
        {
          href: "/devices?status=ONLINE",
          icon: Wifi,
          title: "Online",
          badge:
            typeof summary?.online === "number"
              ? summary.online.toString()
              : null,
          badgeColor: "#22c55e",
        },
        {
          href: "/devices?status=OFFLINE",
          icon: WifiOff,
          title: "Offline",
          badge:
            typeof summary?.offline === "number"
              ? summary.offline.toString()
              : null,
          badgeColor: "#ef4444",
        },
        {
          href: "/devices/add",
          icon: Add,
          title: "Register Device",
          badge: null,
        },
      ],
    },
  ];

  if (user?.is_staff) {
    sections.push({
      title: "Admin",
      pages: [
        {
          href: "/devices/provision",
          icon: PrecisionManufacturingOutlined,
          title: "Provision Devices",
          badge: null,
        },
        {
          href: "/settings/organizations",
          icon: Business,
          title: "Organizations",
          badge: null,
        },
        {
          href: "/settings/api-keys",
          icon: VpnKey,
          title: "API Keys",
          badge: null,
        },
      ],
    });
  }

  return sections;
}

export default NavItems;
